import { Stack } from "@mui/material";
import { FoodsIconButton, Typography } from "@foodpilot/foods";

type RemovableTagProps = {
    backgroundColor: string;
    foregroundColor: string;
    label: string;
    onRemove?: () => void;
    removeLabel?: string;
};

/** Shared removable tag from Figma entity-list nodes `12817:68711` and `13154:221666`. */
export const RemovableTag = ({ backgroundColor, foregroundColor, label, onRemove, removeLabel }: RemovableTagProps) => (
    <Stack
        component="span"
        direction="row"
        alignItems="center"
        sx={(theme) => ({
            backgroundColor,
            borderColor: backgroundColor,
            borderRadius: theme.spacing(0.5),
            borderStyle: theme.custom.strokes.containerDivider.style,
            borderWidth: theme.custom.strokes.containerDivider.width,
            boxSizing: "border-box",
            color: foregroundColor,
            display: "inline-flex",
            flexShrink: 0,
            gap: theme.spacing(0.25),
            height: theme.spacing(3.5),
            paddingBlock: theme.spacing(0.25),
            paddingInlineEnd: theme.spacing(0.25),
            paddingInlineStart: theme.spacing(1),
        })}
    >
        <Typography component="span" variant="body-semibold" noWrap sx={{ color: "inherit" }}>
            {label}
        </Typography>
        {onRemove !== undefined && removeLabel !== undefined && (
            <FoodsIconButton
                size="xs"
                icon="close"
                buttonProps={{
                    "aria-label": removeLabel,
                    onClick: onRemove,
                    type: "button",
                    sx: {
                        color: "inherit",
                        flexShrink: 0,
                        "&:hover, &:active": { backgroundColor: "transparent", color: "inherit" },
                    },
                }}
            />
        )}
    </Stack>
);
